import PropTypes from 'prop-types'
import React from 'react'

const FactLoader = ({ facts }) => {
  const getRandomFact = () => {
    return facts[Math.floor(Math.random() * facts.length)]
  }

  const activeFact = getRandomFact()
  const { header, fact, link: { title, url: { path } } } = activeFact.node

  return (
    <section className='facts'>
      <h1 className='fact__title'>{header}</h1>
      <p className='fact__description'>{fact}</p>
      <a
        href={path}
        className='btn btn--secondary-outline btn--icon-right'
        target='_blank'
      >
        {title}
        <span className='fas fa-long-arrow-alt-right' />
      </a>
    </section>
  )
}

export default FactLoader

FactLoader.propTypes = {
  facts: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/fact-loader.js